import { NavigationElement } from '../../models';

export const getParentModulePath = (navigationElement: NavigationElement | undefined): string | undefined => {
    if (!navigationElement) {
        return undefined;
    }

    if (navigationElement.isModule) {
        return navigationElement.path;
    }

    return getParentModulePath(navigationElement.parent);
};
